const on = (eventType, element, callback, useCapture = false) => {
    element.addEventListener(eventType, callback, useCapture);
};

export {on};
